import {Space} from "antd";
import {ServiceOrderDrawerOrderInfoProps} from "..";
import {ServiceOrderWorkDeliveryDeliveredWork} from "./delivered-work";
import {ServiceOrderWorkDeliveryHeader} from "./header";
import {GetStoreServiceOrderApiResponse} from "../../../../../../../../react-query-hooks/store/services/get-store-service-order/types";

export type ServiceOrderWorkDeliveryProps = {
  status: ServiceOrderDrawerOrderInfoProps["status"];
  productServiceDeliveries: GetStoreServiceOrderApiResponse["order"]["productServiceDeliveries"];
};

export function ServiceOrderWorkDelivery({
  status,
  productServiceDeliveries,
}: ServiceOrderWorkDeliveryProps) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <ServiceOrderWorkDeliveryHeader
        hasMaxedOutDelivery={productServiceDeliveries.length > 1}
        status={status}
      />
      <ServiceOrderWorkDeliveryDeliveredWork
        productServiceDeliveries={productServiceDeliveries}
      />
    </Space>
  );
}
